import toastMessage from "../../utils/toastMessage";
import axios from "axios";
import { getStorage } from "../../utils/storage";
import api from "../../utils/api";

export const fetchReconciliation = async (lng = "english", params) => {
  const { accessToken } = await getStorage();
  let headers = {
    "Content-Type": "application/json;charset=UTF-8",
  };

  try {
    if (accessToken) {
      headers.Authorization = "Bearer " + accessToken;
    }

    const options = {
      method: "GET",
      url: `${api("report")}/merchant/reconciliations`,
      data: null, //force axios send headers content type
      params,
      headers,
    };

    const data = await axios(options);

    return data.data;
  } catch (error) {
    toastMessage("error", error);
  }
};

export const fetchProcessingReport = async (lng = "english", params) => {
  const { accessToken } = await getStorage();
  let headers = {
    "Content-Type": "application/json;charset=UTF-8",
  };

  try {
    if (accessToken) {
      headers.Authorization = "Bearer " + accessToken;
    }

    console.log("params", params);

    const options = {
      method: "GET",
      url: `${api("report")}/merchant/reconciliations/${
        params.reconciliationPublicId
      }/processingReport`,
      data: null, //force axios send headers content type
      params: {
        merchantId: params.merchantId,
      },
      headers,
    };

    const data = await axios(options);

    return data.data;
  } catch (error) {
    toastMessage("error", error);
  }
};

export const fetchReconciliationSettlements = async (
  lng = "english",
  params
) => {
  const { accessToken } = await getStorage();
  let headers = {
    "Content-Type": "application/json;charset=UTF-8",
  };

  try {
    if (accessToken) {
      headers.Authorization = "Bearer " + accessToken;
    }

    const options = {
      method: "GET",
      url: `${api("report")}/merchant/reconciliations/${
        params.reconciliationPublicId
      }/settlements`,
      data: null, //force axios send headers content type
      params: {
        merchantId: params.merchantId,
      },
      headers,
    };

    const data = await axios(options);

    return data.data;
  } catch (error) {
    toastMessage("error", error);
  }
};

export const fetchReconciliationSettlementById = async (
  lng = "english",
  params
) => {
  const { accessToken } = await getStorage();
  let headers = {
    "Content-Type": "application/json;charset=UTF-8",
  };

  try {
    if (accessToken) {
      headers.Authorization = "Bearer " + accessToken;
    }

    const options = {
      method: "GET",
      url: `${api("report")}/merchant/reconciliations/${
        params.reconciliationPublicId
      }/settlements/${params.settlementId}`,
      data: null, //force axios send headers content type
      params: {
        merchantId: params.merchantId,
      },
      headers,
    };

    const data = await axios(options);

    return data.data;
  } catch (error) {
    toastMessage("error", error);
  }
};

export const fetchReconciliationActivities = async (
  lng = "english",
  params
) => {
  const { accessToken } = await getStorage();
  let headers = {
    "Content-Type": "application/json;charset=UTF-8",
  };

  try {
    if (accessToken) {
      headers.Authorization = "Bearer " + accessToken;
    }

    const options = {
      method: "GET",
      url: `${api("report")}/merchant/reconciliations/${
        params.reconciliationPublicId
      }/activities`,
      data: null, //force axios send headers content type
      params: {
        merchantId: params.merchantId,
      },
      headers,
    };

    const data = await axios(options);

    return data.data;
  } catch (error) {
    toastMessage("error", error);
  }
};
